import { AnalyticsConfig, GoogleAnalyticsConfig } from '..';
import { Business } from '../business';
import { z } from 'zod';
export interface Pod {
  id: number;
  podName: string;
  podNumber: number;
  branchID: number;
  googleConfig?: GoogleAnalyticsConfig;
}

export const examplePod: Pod = {
  id: 1,
  podName: 'Test Pod',
  podNumber: 1,
  branchID: 1,
  googleConfig: undefined,
};

export interface PodWithBusinesses extends Pod {
  businesses: Business[];
}

export interface PodDTO {
  podName: string;
  podNumber: number;
  branchID: number;
  googleConfig?: object;
}

export const examplePodDTO: PodDTO = {
  podName: 'Test Pod',
  podNumber: 1,
  branchID: 1,
  googleConfig: undefined,
};

const StringToNumber = z.preprocess(
  (arg) => (typeof arg === 'string' ? Number(arg) : arg),
  z.number(),
);

const GoogleConfigJSON = z.preprocess(
  (arg) => (arg && typeof arg === 'string' ? JSON.parse(arg) : arg),
  AnalyticsConfig.nullish(),
);

export const PodConfig = z.object({
  id: StringToNumber.optional(),
  podName: z.string().optional(),
  podNumber: StringToNumber.optional(),
  branchID: StringToNumber.optional(),
  googleConfig: GoogleConfigJSON,
  podMembers: z.number().array().optional(),
  affiliateMembers: z.number().array().optional(),
  podBusinesses: z.number().array().optional(),
});

export type PodConfigDTO = z.infer<typeof PodConfig>;
